import { WebApiActionGet, WebApiActionPost, QueryParams, WebApiItems } from "components/ajax/WebApi";
import rootUrl from "./url";
import { number, string, bool } from "prop-types";

const baseUrl = rootUrl + "prestupy/";


export interface PrestItem {
    Id: number;
    DatPorizeni: Date;
    PuvKlubId?: number;
    PuvKlubNazev: string;
    NovKlubId?: number;
    NovKlubNazev: string;
    Stav: number;
}


export interface Prestup {
    id: number;
    clen_id: number;
    clen_idt: number;
    clen_jm: string;
    clen_pr: string;
    dat_porizeni: Date;
    dat_prestupu?: Date;
    dat_potvrz_ic?: Date;

    popl_dat_platby?: Date;
    popl_castka: number;
    popl_var_sym: string;
    popl_spec_sym: string;
    popl_cis_uctu: string;

    puv_klub_id?: number;
    puv_klub_naz: string;
    nov_klub_id?: number;
    nov_klub_naz: string;

    odst_termin?: Date;
    odst_pozadovano: boolean;
    odst_zaplaceno: boolean;
    odst_dat_zaplac?: Date;
    odst_max_castka: number;
    odst_castka: number;
    odst_doklad: boolean;

    zak_startu_do?: Date;

    stav: number;
}

export interface NovyPrest {
    idtClena: string;
    nov_klub_id?: number;
    overit_clena: boolean;
}



export const GetSeznamPrestupu = function (): WebApiActionGet<WebApiItems<Prestup>> {
    return new WebApiActionGet<WebApiItems<Prestup>>(baseUrl + 'seznam');
}


export const GetSeznamPrestupuClena = function (clenId: number): WebApiActionGet<WebApiItems<PrestItem>> {
    return new WebApiActionGet<WebApiItems<PrestItem>>(baseUrl + `seznam-clena/${clenId}`);
}


export const GetPrestup = function (prestupId: number): WebApiActionGet<Prestup> {
    return new WebApiActionGet<Prestup>(baseUrl + `prestup/${prestupId}`);
}

export const NovyPrestup = function (): WebApiActionPost<NovyPrest, Prestup> {
    return new WebApiActionPost<NovyPrest, Prestup>(baseUrl + 'novy');
}

export const PotvrzeniPrestupu = function (prestupId: number): WebApiActionPost<{}, Prestup> {
    return new WebApiActionPost<{}, Prestup>(baseUrl + `potvrzeni/${prestupId}`);
}

export const ZamitnutiPrestupu = function (prestupId: number): WebApiActionPost<{}, Prestup> {
    return new WebApiActionPost<{}, Prestup>(baseUrl + `zamitnuti/${prestupId}`);
}

export const StornoPrestupu = function (prestupId: number): WebApiActionPost<{}, Prestup> {
    return new WebApiActionPost<{}, Prestup>(baseUrl + `storno/${prestupId}`);
}
